import { SkeletonBar } from 'worldover/ui-components';

export const LandingPageLoading = () => {
  return (
    <div className='flex flex-col gap-6 m-auto mt-4 p-8 max-w-[1200px]'>
      <SkeletonBar className='h-[50px] w-[400px]' />
      <SkeletonBar className='h-[18px] w-[350px]' />
      <SkeletonBar className='h-[350px] w-full' />
      <div className='mt-12'>
        <SkeletonBar className='h-[350px] w-full' />
      </div>
    </div>
  );
};
